import {useTranslation} from "react-i18next";

export const bikeType = () => {
  const {t} = useTranslation();

  return [
    {id: "ROAD_BIKE", name: t('bike_type.road_bike')},
    {id: "MOUNTAIN_BIKE", name: t('bike_type.mountain_bike')},
    {id: "ELECTRIC_BIKE", name: t('bike_type.electric_bike')},
    {id: "HYBRID_BIKE", name: t('bike_type.hybrid_bike')},
    {id: "GRAVEL_ROAD_BIKE", name: t('bike_type.gravel_road_bike')},
    {id: "FOLDING_BIKE", name: t('bike_type.folding_bike')},
    {id: "TOURING_BIKE", name: t('bike_type.touring_bike')},
    {id: "OTHER", name: t('bike_type.other')},
  ];
}
